module.exports = __webpack_public_path__ + "img/login_02.c87aa32f.jpg";